<app-topbar></app-topbar>
<div class="container mr-top-56">
   <h1 class="mainhdng mr-bttm-30 pd-lftrt-15-mob">Profile</h1>
   <!-- Payment Detail -->
   <div class="common  mr-top-20 mr-bttm-68 prfldata_div frMbl bordergray col-md-8">
	   <div class="col-md-12">
	   <div class="row">
		   
      <div class="col-md-3 prfl_pictr_side">
         <div class="common roundprflimg" data-toggle="modal" data-target="#changepictureModal">
            <!-- <img src="assets/images/prflimg.png" class="prflimg"> -->
            <img *ngIf = "V_Profile_image; else defaultImage" src="{{fileuploadurl}}{{V_Profile_image}}" class="prflimg">
            <ng-template #defaultImage>
               <img src="assets/images/change_img.png" class="prflimg">
            </ng-template>
            <div class="editicondiv" >
               <img src="assets/images/editicon.png">
            </div>
         </div>
         <div class="common mr-top-20">
            <p class="">
               <a href="javascript:void(0)" class="rmbrme clrblue" data-toggle="modal" data-target="#changepictureModal">Change picture</a>
            </p>
         </div>
      </div>
      <div class="col-md-9 prfl_data_side">
         <div class="prflhdng mr-bttm-68">
            <h6 class="pyhdng mr-bttm-5">{{V_firstname}} {{V_lastname}}</h6>
            <p class="text-left"><a href="javascript:void(0)" class="boxpara clrblue edit_name_btn" data-toggle="modal" data-target="#changenameModal">Edit Name</a> </p>
         </div>
         
         <!-- <div class="common mr-top-20">
            <button class="updtbttn">Update</button>
            </div> -->
      </div>
		   
	   </div>
	</div>
	   <div class="col-12">
   <div class="row common prfldatadiv prfldatadiv2 frMbl mx-auto">
            <div class="col-md-1 pd-top-5 prfldatadiv_img">
               <img src="assets/images/messageicon.png">
            </div>
            <div class="col-md-7 prfldatadiv_value">
               <p class="boxpara" id="enterEmailValue">{{V_email == null || V_email == '' ? '----------------' : V_email}}</p>
            </div>
            <div class="col-md-4 prfldatadiv_editable">
               <p class="text-right">
                  <a href="javascript:void(0)" class="rmbrme clrblue webshw" data-toggle="modal" data-target="#changeemailModal">Change your email</a>
                  <a href="javascript:void(0)" class="rmbrme clrblue mblshw" data-toggle="modal" data-target="#changeemailModal">Edit</a>
               </p>
            </div>
         </div>
         <div class="row common prfldatadiv prfldatadiv2 frMbl mx-auto">
            <div class="col-md-1 pd-top-5 prfldatadiv_img">
               <img src="assets/images/phoneicon.png">
            </div>
            <div class="col-md-7 prfldatadiv_value">
               <p class="boxpara" id="enterPhoneValue">{{V_contact == null || V_contact == '' ? '----------------' : V_contact | mask: '(000) 000-0000'}}</p>
            </div>
            <div class="col-md-4 prfldatadiv_editable">
               <p class="text-right">
                  <a href="javascript:void(0)" class="rmbrme clrblue webshw edit_phone_btn" data-toggle="modal" data-target="#changephoneModal">Change your phone</a>
                  <a href="javascript:void(0)" class="rmbrme clrblue mblshw" data-toggle="modal" data-target="#changephoneModal">Edit</a>
               </p>
            </div>
         </div>
         <div class="row common prfldatadiv prfldatadiv2 frMbl mx-auto">
            <div class="col-md-1 pd-top-5 prfldatadiv_img">
               <img src="assets/images/locationicon.png">
            </div>
            <div class="col-md-7 prfldatadiv_value">
               <div *ngIf="V_address; else noAddress">
                  <p class="boxpara">
                     <span *ngIf="V_address">{{V_address}}, </span><span *ngIf="V_city">{{V_city}}, </span><span *ngIf="V_State"><span *ngFor="let state of states"><span *ngIf="state.id == V_State">{{state.name}}</span></span>, </span><span *ngIf="V_zipcode">{{V_zipcode}}, </span><span *ngFor="let country of countries"><span *ngIf="country.id == V_Country">{{country.name}}</span></span>
                  </p>
               </div>
               <ng-template #noAddress>
                  <p class="boxpara">----------------</p>
               </ng-template>
            </div>
            <div class="col-md-4 prfldatadiv_editable">
               <p class="text-right">
                  <a href="javascript:void(0)" class="rmbrme clrblue webshw edit_address_btn" data-toggle="modal" data-target="#changeaddressModal">Change your address</a>
                  <a href="javascript:void(0)" class="rmbrme clrblue mblshw" data-toggle="modal" data-target="#changeaddressModal">Edit</a>
               </p>
            </div>
         </div>
         <div class="row common prfldatadiv prfldatadiv2 frMbl mx-auto">
            <div class="col-md-1 pd-top-5 prfldatadiv_img">
               <img src="assets/images/keyicon.png">
            </div>
            <div class="col-md-7 prfldatadiv_value">
               <p class="boxpara">********</p>
            </div>
            <div class="col-md-4 prfldatadiv_editable">
               <p class="text-right">
                  <a href="javascript:void(0)" class="rmbrme clrblue webshw" data-toggle="modal" data-target="#changepasswordModal">Change password</a>
                  <a href="javascript:void(0)" class="rmbrme clrblue mblshw" data-toggle="modal" data-target="#changepasswordModal">Edit</a>
               </p>
            </div>
         </div>
         
         <!-- <div class="common mr-top-20">
            <button class="updtbttn">Update</button>
            </div> -->
</div>
   </div>
	<div class="common  mr-top-20 mr-bttm-68 prfldata_div frMbl bordergray col-md-4 rightprofilesec">
	  <div class="common prfldatadiv prfldatadiv2 frMbl">
			 <div class="profiletopsec">
				  <div class="col-md-3 prfldatadiv_img">
                     <img src="assets/images/bloomview-icon.png">
            	  </div>
				 <div class="col-md-9 prfldatadiv_value">
               		<p class="boxpara"><b>${{V_credits == null || V_credits == '' ? '0' : V_credits}}</b><span>Credits</span></p>
					 <div class="prfldatadiv_editable">
               <p class="text-left">
                  <a href="javascript:void(0)" class="rmbrme clrblue webshw open_credit_modal" data-toggle="modal" data-target="#purchaseCreditsModal" (click) ="openCreditsModal()">Purchase Credits</a>
                  <a href="javascript:void(0)" class="rmbrme clrblue mblshw open_credit_modal" data-toggle="modal" data-target="#purchaseCreditsModal" (click) ="openCreditsModal()">Edit</a>
                  <a href="javascript:void(0)" class="rmbrme clrblue open_credit_modal" data-toggle="modal" data-target="#purchaseCreditsModalauto" (click) ="openCreditsModalauto()">Auto Top-up</a>
               </p>
            </div>
           		 </div>
			 </div>
		     <div class="profilebottomsec">
		         <div class="col-12 promoc my-2">Promo Code?</div>
                <div class="col-12">
                  <div class="row">
                     <div class="col-md-8 col-9 applyinput pr-0"><input type="text" name=""></div>
                     <div class="col-md-4 col-3 applyinbtn p-0"><button class="btn">Apply</button></div>
                  </div>               
                </div>
		     </div>
           
            
            
         </div>
      
   </div>
	
</div>
<!-- Change Image Modal -->
<div class="modal fade in" id="changepictureModal">
   <div class="modal-dialog ">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changeimagebody">
            <div class="common ">
               <div class="changeimagediv text-center mr-top-60">
                  <form (submit)="uploadFileToActivity()">
                     <!-- <img src="assets/images/change_img.png" class="changeimg" id="profile_image_src"> -->
                     <img *ngIf = "V_Profile_image; else defaultImageNew" src="{{fileuploadurl}}{{V_Profile_image}}" (click) ="triggerFileUpload()"  class="changeimg" id="profile_image_src">
                     <ng-template #defaultImageNew>
                        <img src="assets/images/change_img.png" class="changeimg" id="profile_image_src" (click) ="triggerFileUpload()"> 
                     </ng-template>
                     <input type="file" class="upldimgfile" id="profile_image" name="img" accept="image/*" (change)="handleFileInput($event)">
                     <div class="common upldpctrtxt text-center">
                        <p class="text-center mr-bttm-35"><a  href="javascript:void(0)" class="rmbrme clrblue" (click) ="triggerFileUpload()">Upload picture</a><span class="inputValidation text-center">{{ profile_imageError }}</span> </p>
                        <button class="savebttn">{{V_Profile_image == '' || V_Profile_image == null ? 'Save' : 'Update'}}</button>
                        <button class="cancelbttn cancelbttn_profile" data-dismiss="modal">Close</button>
                     </div>
                     <div class="common text-success sccsmsgdiv" >{{imageUpdate}}</div>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Change Image Modal -->
<!-- Change Email Modal -->
<div class="modal fade in" id="changeemailModal" >
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody" id="changeEmailPopup">
            <div class="common billingform changenumber">
               <form (ngSubmit)="changeEmail($event)">
                  <h6 class="sucssheading clrgry text-left">Change your email</h6>
                  <div class="form-group">
                     <input type="email" name="" ngClass="form-control" placeholder="Enter Email" id="enterEmail" value="{{V_email}}">
                     <span class="inputValidation">{{ emailError }}</span>
                  </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn">Update</button>
                     <button class="cancelbttn cancelbttn_email" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{emailUpdate}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Change Email Modal -->
<!-- Phone Number Modal -->
<div class="modal fade in" id="changephoneModal">
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form (ngSubmit) = "changePhone($event)">
                  <h6 class="sucssheading clrgry text-left">Change your phone</h6>
                  <div class="form-group">
                     <input type="text" name="enterPhone" class="form-control" placeholder="(123) 456-7890" value="{{V_contact}}" id="enterPhone" maxlength="15" minlength="10" mask='(000) 000-0000'>
                     <span class="inputValidation">{{ contactError }}</span>
                  </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn">{{V_contact == '' || V_contact == null ? 'Save' : 'Update'}}</button>
                     <button class="cancelbttn cancelbtn_phone" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{phoneUpdate}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Phone Number Modal -->
<!-- Address Modal -->
<div class="modal fade in" id="changeaddressModal">
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form (ngSubmit) = "changeAddress($event)">
                  <h6 class="sucssheading clrgry text-left">Change your address</h6>
                  <div class="form-group">
                     <input type="text" class="form-control" placeholder="Address" id="enterAddress" value="{{V_address}}">
                     <span class="inputValidation">{{ address_line1Error }}</span>
                  </div>
                  <div class="form-group row">
                     <div class="col-md-6 col-sm-6 col-xs-6">
                        <!-- <input type="text" class="form-control" placeholder="State"> -->
                        <select class="pymntmthds form-control" id="enterCountry" autocomplete="off" (change)="changeState($event.target.value)">
                           <option value="">Select Country</option>
                           <option *ngFor="let country of countries" [value]="country.id"
                           [selected]="country.id == V_Country">
                           {{country.name}}
                           </option>
                        </select>
                        <span class="inputValidation">{{ countryError }}</span>
                     </div>
                     <div class="col-md-6 col-sm-6 col-xs-6">
                        <div *ngIf="stateLoading else selectState">
                           <img src="assets/images/loading.gif" class="loading_gif"/>
                        </div>
                        <ng-template #selectState>
                           <select class="pymntmthds form-control" id="enterState" autocomplete="off">
                              <option value="">Select State</option>
                              <option *ngFor="let state of states" [value]="state.id"
                              [selected]="state.id == V_State">
                              {{state.name}}
                              </option>
                           </select>
                        </ng-template>
                        <span class="inputValidation">{{ stateError }}</span>
                     </div>
                  </div>
                  <div class="form-group row mr-bttm-0">
                     <div class="col-md-6 col-sm-6 col-xs-6">
                        <input id="enterCity" type="text" class="form-control" placeholder="City" value="{{V_city}}">
                        <span class="inputValidation">{{ cityError }}</span>
                     </div>
                     <div class="col-md-6 col-sm-6 col-xs-6">
                        <input type="text" class="form-control" placeholder="Zip Code" value="{{V_zipcode}}" id="enterZip">
                        <span class="inputValidation">{{ zipError }}</span>
                     </div>
                  </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn">{{V_address == '' || V_address == null ? 'Save' : 'Update'}}</button>
                     <button class="cancelbttn cancelbttn_address" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{addressUpdate}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Address Modal -->
<!-- Password Modal -->
<div class="modal fade in" id="changepasswordModal">
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form (submit) = "updatePassword($event)">
                  <h6 class="sucssheading clrgry text-left">Change your password</h6>
                  <div class="form-group">
                     <input type="password" name="" class="form-control" placeholder="Current Password" id="oldPassword">
                     <span class="inputValidation">{{OldPassError}}</span>
                  </div>
                  <div class="form-group">
                     <input type="password" name="" class="form-control" placeholder="New Password" id="Newpassword" (keyup) = "enterPassword($event.target.value)">
                     <span class="inputValidation">{{newPassError}}</span>
                     <span class="inputValidation">{{ validPasswordMsg }}</span>
                  </div>
                  <div class="form-group mr-bttm-0">
                     <input type="password" name="" class="form-control" placeholder="Confirm Password" id="Confirmpassword">
                     <span class="inputValidation">{{confirmPassError}}</span>
                  </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn" [disabled] = "validPassword ? false : true">Update</button>
                     <button class="cancelbttn cancelbttn_pwd" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{passwordMessage}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Password Modal -->
<!-- Change Name Modal -->
<div class="modal fade in" id="changenameModal">
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form (ngSubmit)="changeName($event)">
                  <h6 class="sucssheading clrgry text-left">Change your name</h6>
                  <div class="form-group">
                     <input ype="text" name="" ngClass="form-control" placeholder="Enter First Name" id="enterFName" value="{{V_firstname}}">
                     <span class="inputValidation">{{ first_nameError }}</span>
                  </div>
                  <div class="form-group">
                     <input type="text" name="" ngClass="form-control" placeholder="Enter Last Name" id="enterLName" value="{{V_lastname}}">
                     <span class="inputValidation">{{ last_nameError }}</span>
                  </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn">Save</button>
                     <button class="cancelbttn" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{nameUpdate}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Change Name Modal -->
<!-- Change Name Modal -->
<div class="modal fade in" id="purchaseCreditsModal">
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form [formGroup]="purchase_credit_form" (ngSubmit)="purchase_credit_submit()">
                  <h6 class="sucssheading clrgry text-left">Purchase Credits</h6>
                  <div class="form-group">
                     <input type="number" formControlName = "amount" name="" ngClass="form-control" placeholder="Enter Amount" min="1" id="amount" autocomplete="off" maxlength="5" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (keyup) ="enterAmount()">
                     <div *ngIf="credit_form_submitted && purchase_credit_f.amount.invalid"><span class="inputValidation" *ngIf="purchase_credit_f.amount.errors.required">Amount is required.</span></div>
                  </div>
                  <div class="form-group">
                     <select  class="ordrslct wd-70 newslct" class="form-control"  formControlName = "card_id" (change) ="selectCard()">
                        <option value="">Select Card</option>
                        <option *ngFor="let card of cardList" [value]="card.card_id">
                        {{card.card_brand}} *{{card.card_last4}}
                        </option>
                     </select>
                     <div *ngIf="credit_form_submitted && purchase_credit_f.card_id.invalid"><span class="inputValidation" *ngIf="purchase_credit_f.card_id.errors.required">Card is required.</span></div>
                  </div>
                  <div class="form-group">
                     <a href="javascript:void(0)" (click) = "addNewCard()" class="boxpara pull-left" data-toggle="modal" data-target="#addCard">Add New Card</a>
                 </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn">Submit</button>
                     <button class="cancelbttn close_purchase_modal" data-dismiss="modal">Close</button>
                  </div>
                  <span class="inputValidation">{{creditErrorMsg}}</span>
                  <div class="common text-success sccsmsgdiv">{{creditSuccessMsg}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- Change Name Modal -->

<!---Top Modal Start-->
<div class="modal fade in" id="purchaseCreditsModalauto">
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form [formGroup]="purchase_credit_formauto" (ngSubmit)="purchase_credit_submitauto()">
                  <h6 class="sucssheading clrgry text-left">Auto Top-up Credits</h6>
                  <div class="form-group">
                     <input type="number" [(ngModel)]="topup_amount" formControlName = "amounttop1" name="" ngClass="form-control" placeholder="Top up amount" min="1" id="amounttop1" autocomplete="off" maxlength="5" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (keyup) ="enterAmountauto()">
                     <div *ngIf="credit_form_submittedauto && purchase_credit_fauto.amounttop1.invalid"><span class="inputValidation" *ngIf="purchase_credit_fauto.amounttop1.errors.required">Amount is required.</span></div>
                  </div>
				   <p>Topup when credit reaches below</p>
				   <div class="form-group">
                     <input type="number" [(ngModel)]="topup_threshold"  formControlName = "amounttop2" name="" ngClass="form-control" placeholder="Top up amount" min="1" id="amounttop2" autocomplete="off" maxlength="5" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (keyup) ="enterAmountauto()">
                     <div *ngIf="credit_form_submittedauto && purchase_credit_fauto.amounttop2.invalid"><span class="inputValidation" *ngIf="purchase_credit_fauto.amounttop2.errors.required">Amount is required.</span></div>
                  </div>
                  <div class="form-group">
                     <select  class="ordrslct wd-70 newslct" class="form-control"  formControlName = "card_id" (change) ="selectCard()">
                        <option value="">Select Card</option>
                        <option *ngFor="let card of cardList" [value]="card.id" [selected]="card.id == topup_card_id" >
                        {{card.card_brand}} *{{card.card_last4}}
                        </option>
                     </select>
                     <div *ngIf="credit_form_submittedauto && purchase_credit_fauto.card_id.invalid"><span class="inputValidation" *ngIf="purchase_credit_fauto.card_id.errors.required">Card is required.</span></div>
                  </div>
                  <div class="form-group">
                     <a href="javascript:void(0)" (click) = "addNewCardauto()" class="boxpara pull-left" data-toggle="modal" data-target="#addCard">Add New Card</a>
                 </div>
                  <div class="common changenumberbttn text-left">
                     <button class="savebttn">Submit</button>
                     <button class="cancelbttn close_purchase_modalauto" data-dismiss="modal">Close</button>
                  </div>
                  <span class="inputValidation">{{creditErrorMsg}}</span>
                  <div class="common text-success sccsmsgdiv">{{creditSuccessMsg}}</div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!---Top Modal End-->

<!-- add payment card Modal -->
<div class="modal centerModalNew fade in" id="addCard">
   <div class="modal-dialog ">
   <div class="modal-content">    
   
   
   <!-- Modal body -->
   <div class="modal-body changeimagebody">
       <div class="common billingform addCard_div">
           <div class="changeimagediv text-center mr-top-60">
               
               <form [formGroup]="add_card_form" (ngSubmit)="add_card_submit()">
                   <h6 class="sucssheading clrgry text-left">Add New Card</h6>
                   <div class="common crditcrdfrm">
                       <div class="form-group">
                          <input formControlName="name" type="text" class="form-control" id="credit_name" placeholder="Enter name" >
                          <div *ngIf="add_card_submitted && add_card_f.name.invalid">
                           <span class="inputValidation" *ngIf="add_card_f.name.errors.required">Name is required.</span>
                           </div>
                       </div>
                       <div class="form-group">
                          <input formControlName="number" type="text" class="form-control" id="credit_number" placeholder="Enter Credit Number"  maxlength="16">
                          <div *ngIf="add_card_submitted && add_card_f.name.invalid">
                           <span class="inputValidation" *ngIf="add_card_f.name.errors.required">Credit Number is required.</span>
                           </div>
                       </div>
                       <div class="form-group row">
                          <div class="col-md-4 col-sm-4 col-xs-4">
                             <select id="expYear" class="pymntmthds form-control" placeholder="324" 
                                autocomplete="off" formControlName="exp_year">
                                <option value="">Select Year</option>
                                <option *ngFor = "let year of yearList" value="{{year.value}}">{{year.year}}</option>
                             </select>
                             <div *ngIf="add_card_submitted && add_card_f.exp_year.invalid">
                               <span class="inputValidation" *ngIf="add_card_f.exp_year.errors.required">Card Expiry Year is required.</span>
                               </div>
                          </div>
                          <div class="col-md-4 col-sm-4 col-xs-4">
                             <select id="card_expiry_date" formControlName="exp_month" class="pymntmthds form-control" placeholder="324"
                                autocomplete="off" >
                                <option value="">Select Month</option>
                                <option value="1">01</option>
                                <option value="2">02</option>
                                <option value="3">03</option>
                                <option value="4">04</option>
                                <option value="5">05</option>
                                <option value="6">06</option>
                                <option value="7">07</option>
                                <option value="8">08</option>
                                <option value="9">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                             </select>
                             <div *ngIf="add_card_submitted && add_card_f.exp_month.invalid">
                               <span class="inputValidation" *ngIf="add_card_f.exp_month.errors.required">Card Expiry Month is required.</span>
                               </div>
                          </div>
                          <div class="col-md-4 col-sm-4 col-xs-4">
                             <input type="text" class="form-control" placeholder="CVV"  maxlength="4" formControlName="cvv">
                             <div *ngIf="add_card_submitted && add_card_f.cvv.invalid">
                               <span class="inputValidation" *ngIf="add_card_f.cvv.errors.required">CVV is required.</span>
                               </div>
                          </div>
                       </div>
                       <span class="inputValidation">{{StripeCardEror}}</span>
                    </div>
                   
                   <div class="common changenumberbttn text-left">
                           <button class="savebttn" [disabled]="buttonLoading ? true : false">Add</button>
                       <button class="cancelbttn close_card_mdl_add" data-dismiss="modal">Close</button>
                     </div>
                     <div class="common text-success sccsmsgdiv" ></div>
               </form>
   
           </div>
       </div>
   
   </div>
</div>
</div>
</div>